import { render, staticRenderFns } from "./ChatHistoryPage.vue?vue&type=template&id=b9b575b4&scoped=true&"
import script from "./ChatHistoryPage.vue?vue&type=script&lang=js&"
export * from "./ChatHistoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b575b4",
  null
  
)

export default component.exports